module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='Oops. That wasn\'t supposed to happen.\n\nWe don\'t have the page you requested.';
}
return __p;
};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/page-not-found/page-not-found.html
 ** module id = 898
 ** module chunks = 1 2 168
 **/